module.exports = __webpack_public_path__ + "static/media/sector-5.3d66b58c.jpg";